<template>
  <div class="error-page">
    <div class="error-page__content">
      <div class="error-page__error">
        <img src="/img/other/error-page.jpeg" width="100%" alt="Упс" class="p-error__image" />
        <div class="p-error__description">
          <h3 v-if="user" class="p-error__title">{{ $t(`shared.error_page.${error.code}.title`, user.locale) }}</h3>
          <h3 v-else class="p-error__title">{{ $t(`shared.error_page.${error.code}.title`) }}</h3>
          <p class="p-error__message mb-2">
            <template>{{ error.message }}</template>
          </p>
          <router-link :to="{ name: 'dashboard' }" class="ivu-btn ivu-btn-primary ivu-btn-large" tag="i-button">
            <span v-if="user">{{ $t('shared.error_page.link.to_index', user.locale) }}</span>
            <span v-else>{{ $t('shared.error_page.link.to_index') }}</span>
          </router-link>
        </div>
      </div>

      <div v-if="!is_prod && $slots['stack-trace']" class="error-page__trace">
        <slot name="stack-trace"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import { IS_PRODUCTION } from '@shared/helpers/env';
  import { mapGetters } from 'vuex';
  export default {
    props: {
      error: {
        type: Object,
        default: () => ({})
      },

      payload: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        is_prod: IS_PRODUCTION
      }
    },
    computed: {
      ...mapGetters('core/auth', ['user'])
    }
  };
</script>

<style lang="scss">
  .error-page {
    display: flex;
    min-height: 100vh;
    max-height: 100vh;
    justify-content: center;

    &__content {
      width: 500px;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }

    &__error {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__trace {
      margin-top: 15px;
    }

    img {
      border-radius: 10px;
    }
  }

  .p-error {
    &__description {
      color: #7f92a9;
      text-align: center;
    }

    &__title {
      font-size: 28px;
      padding: 20px;
    }

  }
</style>
